// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sliders_wrapper__2vdeX","content":"sliders_content__3pFIa","about":"sliders_about__1KYkY","title":"sliders_title__3UHYe","description":"sliders_description__38_w7"};